import { Stack } from "@mantine/core";
import { QuickStart } from "./components/QuickStart.js";
import { OverviewHero } from "./components/OverviewHero.js";
import { UsageAndBilling } from "./components/UsageAndBilling.js";
import { LearnByWatching } from "./components/LearnByWatching.js";

export const Overview = () => {
  return (
    <Stack gap="1.5rem">
      <OverviewHero />
      <QuickStart />
      <LearnByWatching />
      <UsageAndBilling />

    </Stack>
  );
};
